import { ApiClient } from './client'
import {
  DELETE_EXHIBITION_BOOKMARK,
  POST_EXHIBITION_BOOKMARKS,
} from './endpoints'

export const createExhibitionBookmark = async (exhibitionId: number) => {
  const body = {
    exhibition_id: exhibitionId,
  }
  const res = await ApiClient.post(POST_EXHIBITION_BOOKMARKS, body)
  return res
}

export const deleteExhibitionBookmark = async (exhibitionId: number) => {
  const res = await ApiClient.delete(DELETE_EXHIBITION_BOOKMARK(exhibitionId))
  return res
}
